import BttfAxios from '@features/utils/axios';
import { AxiosResponse } from 'axios';
import { ICompanyEquity } from '@appInterfaces/company.interfaces';

class PublicSharesClass {

  public getSharesEstimations(params: string): Promise<AxiosResponse<{}>> {
    return BttfAxios.get(`/api/public_equity_shares/sells?${params}`,
      res => Promise.resolve(res),
      err => Promise.reject(err)
    );
  }

  public confirmRequest(data: any): Promise<AxiosResponse<any>> {
    return BttfAxios.post(
      '/api/public_equity_shares/sells',
      data,
      (res) => {
        return Promise.resolve(res);
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  }

  

}
const PublicSharesService = new PublicSharesClass();

export default PublicSharesService;
